





















import {
  ItemRequestResultModalEventHandler,
  itemRequestResultModalInitialState,
  ItemRequestResultModalState,
} from '@ajax/vue/components/templates/item-detail/model/modal-state'
import queryString from 'query-string'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

/**
 * 2023/06/14時点のコメント
 * デザインシステムの構築を進めており、このモーダルは新しいデザインシステムに則ったスタイルに近いモーダルである。
 * デザインシステムを全体に適用するより先に部分的に商品リクエストの成否結果の表示に限り
 * 部分的に新しいデザインを適用したため独立したコンポーネントとして実装されているが、
 * 本来はGrowthPalette共通で利用できるモーダルを実装し、商品リクエストの成否結果も共通のモーダルを利用するべきである。
 * したがって、本コンポーネントはデザインシステム実装時に削除される（または汎用コンポーネントに昇格する）予定である。
 */
@Component({})
export default class ItemRequestResultModal extends Vue {
  state: ItemRequestResultModalState = itemRequestResultModalInitialState

  get eventHandler(): ItemRequestResultModalEventHandler {
    return ItemRequestResultModalEventHandler.getInstance()
  }

  get modalClass(): string[] {
    return ['modal-body', this.state.style]
  }

  get headingIconUrl(): string {
    return this.state.style === 'error' ?
      '/assets-proxy/images/common/icon/exclamation.svg' :
      '/assets-proxy/images/common/icon/check.svg'
  }

  created() {
    this.eventHandler.addEventListener(
      (state: ItemRequestResultModalState) => {
        this.state = state
      }
    )

    this.handleMessageIdQuery()
  }

  /**
   * クエリを解釈して事前に定義されたメッセージをモーダルで表示する.
   *
   * クエリを解釈することをこのコンポーネントの責務とするべきかは議論の余地がある。
   * 現時点 2023-06-28 ではよりイージーな実装方針を選択し、このコンポーネントで実行している。
   * @see https://github.com/my-color/front/pull/7393#discussion_r1241746573
   */
  handleMessageIdQuery(): void {
    const maybeMessageId: string | undefined = queryString.parse(location.search).message_id

    if (!maybeMessageId) {
      return
    }

    switch (maybeMessageId) {
      case 'LINE_REQUEST_NOTIFICATION_SUCCESS':
        this.eventHandler.open({
          style: 'success',
          heading: 'お知らせ設定完了',
          messages: [
            '商品が入荷されたらLINEでお知らせします。',
          ],
        })

        return

      case 'LINE_REQUEST_NOTIFICATION_FAILURE':
        this.eventHandler.open({
          style: 'error',
          heading: 'エラー',
          messages: [
            'しばらくしてから、再度お試しください。',
            '改善されない場合は、カスタマーセンターまでお問い合わせください。',
          ],
        })

        return

      default:
        return
    }
  }

  onClose() {
    this.eventHandler.close()
  }
}
